import React from "react"

export default function TLink(props) {
    return (<a className='className="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 tracking-wider font-medium rounded-md text-main-800 bg-main-100 hover:bg-main-50 focus:outline-none focus:border-main-300 focus:shadow-outline-main active:bg-main-200 transition ease-in-out duration-150"' href={props.href}>{props.title}</a>);
}